<template>
  <FilterBar
    ref="filters"
    :all-headers="allHeaders"
    :choosed-headers.sync="choosedHeaders"
    :choosed-headers-show="tableMode"
    data-qa="purch-toolbar"
    :filter_types="types"
    :loading="loading"
    show-table-mode-btns
    :table-mode.sync="table_mode">
    <template #third_activator="{item}">
      <PurchFilters :item="item"/>
    </template>
  </FilterBar>
</template>
<script>
import FilterBar from 'components/common/blocks/FilterBar.vue'
import PurchFilters from 'components/purchasing/PurchFilters.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'purchToolbar',
  data() {
    return {
      filtred: false,
      filters: [],
      // users: [],
      key: 1,
      allHeaders: []
    }
  },
  props: {
    headers: Array,
    tableMode: Boolean,
    loading: Boolean
  },
  async created() {
    this.allHeaders = this.headers.slice(0)
  },
  computed: {
    ...mapGetters({
      changeOrganisation: 'changeOrganisation',
    }),
    table_mode: {
      get() {
        return this.tableMode
      },
      set(value) {
        this.$emit('update:tableMode', value)
      }
    },
    choosedHeaders: {
      get() {
        return this.headers
      },
      set(value) {
        this.$emit('update:headers', value)
      }
    },
    types() {
      const result = [
        {
          id: 1,
          text: this.$t('Purchasing.Applicant'),
          contain: true,
          type: 'Creator',
          value: 'applicants',
          search: [],
        },
      ]
      result.push({
        id: 3,
        text: this.$t('Purchasing.Period'),
        contain: true,
        type: 'Period',
        value: 'period',
        search: [],
      })
      return result
    },
  },
  methods: {
    changeType(item) {
      item.type = this.types.find((el) => { return el.text == item.text }).type
    },
    addFilter() {
      this.filters.push({
        ...this.types[0],
        id: this.key,
      })
      this.key = this.key + 1
    },
  },
  components: {
    FilterBar,
    PurchFilters
  }
}
</script>
<style lang="scss" scoped>
.sticky {
  z-index: 6;
  position: sticky;
  top: 64px !important;
}
.headline {
  font-weight: 600;
}
.divider {
  border-top: none;
  border-bottom: 1px solid var(--v-main__light_green-base) !important;
}

.filters-btn {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  img {
    height: 16px;
    width: 16px;;
  }
  &.open {
    opacity: 0.5;
    &::before {
      background: none;
    }
  }
}
.cancel-btn {
  height: 30px;
  width: 30px;
}
.v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
  opacity: 0;
}
</style>
